import { FC } from 'react';
import { StyledItems } from './ListItem.styles';
import { ListProps } from 'src/types';

const ListItem: FC<ListProps> = ({ children, ...props }) => {
  return <StyledItems {...props}>{children}</StyledItems>;
};

export default ListItem;
